import Vue from "vue";
import VueRouter from "vue-router";
import getRoutes from "./routes";
import store from "../store";
import UIConstants from "../store/ui/constants";
import Cookies from 'js-cookie';

Vue.use(VueRouter);


const createRouter = () => new VueRouter({
    mode: 'history',
    routes: getRoutes(),
    linkActiveClass: "active"
});

const router = createRouter();

export function resetRouter () {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher
}


router.afterEach((to, from, next) => {
    store.dispatch(UIConstants.UIActions.UI_CHANGE_ROUTE, {'route': to.meta.title });
});


router.afterEach((to, from, next) => {
    Vue.nextTick(() => {
        const title = process.env.VUE_APP_TITLE;
        if (to.meta.title) {
            document.title = `${title} | ${to.meta.title}`;
        } else {
            document.title = title;
        }
    })
});


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authenticationRequired)) {
        if (!store.getters.isAuthenticated) {
            // redirect to login
            next({path: '/login', query: { next: to.fullPath }})
        } else {
            next();
        }
    } else {
        next();
    }
});


// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.allowedTo)) {
//         const groups = store.getters.getUserGroupAliases;
//         const organizationAlias = store.getters.getUserOrganizationCategoryAlias;
//         const isSuperuser = store.getters.isSuperuser;
//
//         const userInAllowedGroups = groups.filter(x => to.meta.allowedTo.includes(x)).length;
//         const userInOrganizationWithAlias = to.meta.allowedTo.indexOf(organizationAlias) > -1;
//
//         if (isSuperuser || userInAllowedGroups || userInOrganizationWithAlias) {
//             next();
//         } else {
//              next({path: '/error403'})
//         }
//     } else {
//         next();
//     }
// });

export default router;
